<span class="score-arrow fal fa-fw" *ngIf="hasPreviousValue" [ngClass]="{
  'score-increase fa-arrow-up': (valueCurrent >= valuePrevious),
  'score-decrease fa-arrow-down': (valueCurrent <= valuePrevious),
  'score-unchanged fa-hyphen': (valueCurrent === valuePrevious)
}"></span>